export default "__VITE_ASSET__B$ZFWuhZ__"